module.exports = __webpack_public_path__ + "static/media/service_tile_sci.93cd734d.jpg";